export const $checkboxAll = $('.checkboxAll');
export const $checkboxOptions = $('.checkboxOptions');
export const $filterFormInput = $('#filterFormInput');
export const $accordionHead = $('.accordion__head');